import React from "react";
import { withRouter } from "react-router-dom";
import cookie from "react-cookies";
import { connect } from "react-redux";
import Header from "../../../Components/Header/Header";
import { FloatingLabel, Select } from "react-input-textboxs";
import { Dialog } from "@material-ui/core";
import {
  fetchProducts,
  fetchTeams,
  fetchUserList,
  insertNewUser,
  updateUserDetails,
  requestToFileUpload,
  fetchUserLanguages,
  fetchUserTypes,
  updateExistingKeywords,
} from "./../../../service/action/audio-track-action";
import AddUser from "./../Components/Adduser";
import FileUpload from "./../Components/Fileupload";
import UserList from "./../Components/UserList";
import { Loader } from "./../../../Components/index";
import { API_URL } from "./../../../service/constants/constants";

class SADashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      section: "list",
      model: false,
      userNewTypes: [],
      userLanguages: [],
      userNewList: [],
      selectedKeywords: [],
      filterOtherLanguages: [],
      keywordsAction: "0",
      formValue: {
        toBeUpdated: {},
        loginId: "",
        employeeName: "",
        password: "",
        primary_lang: "",
        lang: [],
        usertype: [],
        user_products: [],
        user_team: "",
        file: "",
      },
    };
    this.renderUpdateModel = this.renderUpdateModel.bind(this);
  }

  componentDidMount() {
    this.props.fetchUserList();
    this.props.fetchProducts();
    this.props.fetchTeams();
    this.props.fetchUserLanguages();
    this.props.fetchUserTypes();
    fetch(`${API_URL}/user-type-details`)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            userNewTypes: result,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
    fetch(`${API_URL}/get-language`)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            userLanguages: result,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
    const UserId = cookie.load("username");
    const requestOptions = {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ UserId }),
    };
    fetch(`${API_URL}/get-user-list`, requestOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            userNewList: result,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
  }

  handleChange(value, key) {
    const { formValue } = this.state;
    formValue[key] = value;
    this.setState({ formValue });
  }

  handleSelectedKeywords(value) {
    console.log("Selected Value", value);
    this.setState({ selectedKeywords: value });
  }

  handleKeywordsAction(value) {
    console.log("Selected Value", value);
    this.setState({ keywordsAction: value });
  }

  handleKeywordsSubmit() {
    const { selectedKeywords, keywordsAction } = this.state;
    console.log("Selected Keywords", selectedKeywords);
    console.log("Keywords Action", keywordsAction);
    var finalKeywords = selectedKeywords.map((item) => {
      return {
        Keywords: item.keywords,
        Language: item.language,
        Product: item.product,
      };
    });
    console.log("Keywords Submission", finalKeywords);
    this.props.updateExistingKeywords(finalKeywords, keywordsAction);
  }

  handleDetailsChange(value, key) {
    const { formValue } = this.state;
    console.log(value);
    if (key === "Usertypedesc") {
      formValue.toBeUpdated[key] = value.toString();
    } else if (key === "OtherLanguages") {
      formValue.toBeUpdated[key] = value.toString();
    } else if (key === "Productdesc") {
      formValue.toBeUpdated[key] = value.toString();
    } else if (value.length !== 0 && key === "status") {
      value === "Active"
        ? (formValue.toBeUpdated[key] = 1)
        : (formValue.toBeUpdated[key] = 0);
    } else {
      formValue.toBeUpdated[key] = value;
    }
    this.setState({ formValue });
  }

  handleFileChange(value, key) {
    const { formValue } = this.state;
    formValue[key] = value.files[0];
    this.setState({ formValue });
  }

  handleSubmit() {
    const { formValue, section, userNewTypes } = this.state;
    const {
      SuperAdminReducer: { userProducts, userTeams },
    } = this.props;
    const LoginId = formValue.loginId;
    const Password = formValue.password;
    const BaseLanguage = formValue.primary_lang;
    const OtherLanguages = formValue.lang;
    const EmployeeName = formValue.employeeName;

    const userFinalTypes = userNewTypes.filter((value) => {
      return formValue.usertype.includes(value.type_description);
    });

    const ut = userFinalTypes.map((item) => {
      return item.type_id;
    });

    const userFinalProducts = userProducts.filter((value) => {
      return formValue.user_products.includes(value.Productdesc);
    });

    const up = userFinalProducts.map((item) => {
      return item.ProductId;
    });

    const userFinalTeam = userTeams.filter((value) => {
      return formValue.user_team.includes(value.TeamName);
    });

    const TeamId = userFinalTeam.map((item) => {
      return item.TeamId;
    });

    const UserPrivilege = ut;
    const ProductIds = up;

    const Createdby = cookie.load("username");
    if (section === "add") {
      this.props.insertNewUser(
        LoginId,
        Password,
        BaseLanguage,
        OtherLanguages.toString(),
        UserPrivilege.toString(),
        Createdby,
        EmployeeName,
        ProductIds.toString(),
        Number(TeamId.toString())
      );
    } else {
      this.props.requestToFileUpload(formValue.file);
    }
  }

  handleModel(value) {
    this.setState({ model: value });
    document.getElementById("overlay").classList.toggle("overlay");
  }

  hanldeUserDetailsUpdate(e) {
    e.preventDefault();
    const {
      formValue: { toBeUpdated },
      userNewTypes,
    } = this.state;
    const {
      SuperAdminReducer: { userProducts, userTeams },
    } = this.props;
    this.handleModel(false);
    const utArray = toBeUpdated.Usertypedesc.split(",");
    const userFinalTypes = userNewTypes.filter((value) => {
      return utArray.includes(value.type_description);
    });
    const ut = userFinalTypes.map((item) => {
      return item.type_id;
    });
    const upArray = toBeUpdated.Productdesc.split(",");
    const userFinalProducts = userProducts.filter((value) => {
      return upArray.includes(value.Productdesc);
    });
    const up = userFinalProducts.map((item) => {
      return item.ProductId;
    });
    const userFinalTeam = userTeams.filter((value) => {
      return toBeUpdated.Team.includes(value.TeamName);
    });

    const TeamId = userFinalTeam.map((item) => {
      return item.TeamId;
    });
    const modifiedBy = cookie.load("username");
    this.props.updateUserDetails(toBeUpdated, ut, up, TeamId, modifiedBy);
  }

  filterLanguages(value) {
    console.log("This is working", value);
    const { filterOtherLanguages, userLanguages } = this.state;
    filterOtherLanguages.push(value);
    const tempFilterLanguages = userLanguages.filter((value) => {
      return !filterOtherLanguages.includes(value);
    });
    console.log("This is after filter language ",tempFilterLanguages);
    this.setState({
      filterOtherLanguages: tempFilterLanguages,
    });
  }

  renderUpdateModel() {
    const {
      formValue: { toBeUpdated },
      userLanguages,
      userNewTypes,
      filterOtherLanguages,
    } = this.state;
    const {
      SuperAdminReducer: { userProducts, userTeams },
    } = this.props;
    let ut = {};
    let up = {};
    const userTypesArray = userNewTypes.map((item) => {
      return item.type_description;
    });
    console.log(toBeUpdated);
    if (typeof toBeUpdated.Usertypedesc === "string") {
      ut = toBeUpdated.Usertypedesc.split(",");
    }

    const userProductsArray = userProducts.map((item) => {
      return item.Productdesc;
    });

    const userTeamsArray = userTeams.map((item) => {
      return item.TeamName;
    });

    if (toBeUpdated.Productdesc !== null) {
      if (typeof toBeUpdated.Productdesc === "string") {
        up = toBeUpdated.Productdesc.split(",");
      }
    } else {
      up = [];
    }

    let otherLanguages = {};
    if (typeof toBeUpdated.OtherLanguages === "string") {
      otherLanguages = toBeUpdated.OtherLanguages.split(",");
    }

    return (
      <Dialog
        open={this.state.model}
        onClose={() => this.handleModel(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        // className="modalDetails"
        // style={{ width: "700px" }}
        // mt={2}
        fullWidth
        maxWidth="md"
      >
        <div style={{ padding: "20px" }}>
          <h2>Update User details</h2>
          <form>
            <FloatingLabel
              label="Login Id"
              type="text"
              readOnly={true}
              value={toBeUpdated.login_id}
              variant="standared"
              onChange={(value) => this.handleDetailsChange(value, "name")}
            />
            <FloatingLabel
              label={"Type New Password"}
              type={"password"}
              value={toBeUpdated.password}
              variant="standared"
              onChange={(value) => this.handleDetailsChange(value, "password")}
            />
            <FloatingLabel
              label="Employee Name"
              type="text"
              value={toBeUpdated.EmployeeName}
              variant="standared"
              onChange={(value) =>
                this.handleDetailsChange(value, "EmployeeName")
              }
            />
            <h3>User Types</h3>
            <Select
              value={ut}
              onChange={(value) =>
                this.handleDetailsChange(value, "Usertypedesc")
              }
              multiple
              filter
              label="Select Usertype...."
              options={userTypesArray}
            />
            <h3>User Products</h3>
            <Select
              value={up}
              onChange={(value) =>
                this.handleDetailsChange(value, "Productdesc")
              }
              multiple
              filter
              label="Select Products...."
              options={userProductsArray}
            />
            <h3>Team</h3>
            <Select
              value={toBeUpdated.Team ? toBeUpdated.Team : userTeamsArray[0]}
              onChange={(value) => this.handleDetailsChange(value, "Team")}
              filter
              label="Select a team...."
              options={userTeamsArray}
            />
            <Select
              value={toBeUpdated.status === 1 ? "Active" : "In Active"}
              onChange={(value) => this.handleDetailsChange(value, "status")}
              filter
              label="Select Usertype...."
              options={["Active", "In Active"]}
            />
            <Select
              value={toBeUpdated.language}
              onChange={(value) => {
                this.filterLanguages(value);
                this.handleDetailsChange(value, "language");
              }}
              filter
              label="Select a base language...."
              options={userLanguages}
            />
            <h3>Other Languages</h3>
            <Select
              value={otherLanguages}
              onChange={(value) =>
                this.handleDetailsChange(value, "OtherLanguages")
              }
              multiple
              filter
              label="Select other languages...."
              options={filterOtherLanguages}
            />

            <div className="btn-wrapper">
              <button
                onClick={(e) => this.hanldeUserDetailsUpdate(e)}
                type="submit"
                className="btn submit-btn"
              >
                Submit
              </button>
              <button
                onClick={() => this.handleModel(false)}
                type="submit"
                className="btn clear-btn"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </Dialog>
    );
  }
  render() {
    const {
      SuperAdminReducer: {
        loading,
        userLanguages,
        userTypes,
        userProducts,
        userTeams,
        keywordsList,
      },
    } = this.props;
    console.log("Keywords List ", keywordsList);
    const { userNewList } = this.state;

    return loading ? (
      <Loader />
    ) : (
      <div className="sa_dashboard-page">
        <div className="right-section">
          <div className="parentTable">
            <Header page="Administrator" />
            {this.state.model ? this.renderUpdateModel() : null}
            <div className="btn-header">
              <ul className="btn-wrapper">
                <li
                  onClick={() => this.setState({ section: "list" })}
                  className="btn blue-btn"
                >
                  List
                </li>
                <li
                  onClick={() => this.setState({ section: "upload" })}
                  className="btn download-btn"
                >
                  Upload
                </li>
                <li
                  onClick={() => this.setState({ section: "add" })}
                  className="btn green-btn"
                >
                  Add user
                </li>
              </ul>
            </div>
            {this.state.section === "add" ? (
              <AddUser
                formValue={this.state.formValue}
                handleChange={(value, key) => this.handleChange(value, key)}
                handleSubmit={() => this.handleSubmit()}
                userLanguages={userLanguages}
                userTypes={userTypes}
                userProducts={userProducts}
                userTeams={userTeams}
              />
            ) : this.state.section === "upload" ? (
              <FileUpload
                formValue={this.state.formValue}
                selectedKeywords={this.state.selectedKeywords}
                handleFileChange={(value, key) =>
                  this.handleFileChange(value, key)
                }
                handleSubmit={() => this.handleSubmit()}
                handleSelectedKeywords={(value) =>
                  this.handleSelectedKeywords(value)
                }
                handleKeywordsAction={(value) =>
                  this.handleKeywordsAction(value)
                }
                handleKeywordsSubmit={() => this.handleKeywordsSubmit()}
                existingKeywordsList={
                  keywordsList.length > 0 ? keywordsList : []
                }
              />
            ) : (
              <UserList
                model={this.state.model}
                userNewData={userNewList}
                userNewTypes={userTypes}
                handleChange={(value, key) => this.handleChange(value, key)}
                handleModel={(value) => this.handleModel(value)}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    userLogin,
    SuperAdminReducer,
    userLanguages,
    userTypes,
    userProducts,
    userTeams,
  } = state;

  return {
    SuperAdminReducer,
    userLogin,
    userLanguages,
    userTypes,
    userProducts,
    userTeams,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchProducts,
    fetchTeams,
    fetchUserTypes,
    fetchUserLanguages,
    fetchUserList,
    insertNewUser,
    updateUserDetails,
    requestToFileUpload,
    updateExistingKeywords,
  })(SADashboard)
);
